import { Box, HStack, Heading, Text } from '@chakra-ui/react'
import { useSync } from '../../../providers/SyncProvider'

interface TodaySoFarProps {
  /** From GET me/profile (server-computed, P7-7). Undefined offline, shown as "—". */
  today: { doors: number; conversations: number } | undefined
}

function Stat({ value, label }: { value: number | string; label: string }) {
  return (
    <Box flex="1 1 6rem" borderWidth="1px" borderColor="border.muted" borderRadius="md" bg="bg.subtle" p={3}>
      <Text fontSize="2xl" fontWeight="semibold">{value}</Text>
      <Text color="fg.muted" fontSize="sm">{label}</Text>
    </Box>
  )
}

/** [Canvasser redesign Phase 7, P7-7] Today's doors + conversations (server) and what's still on the phone. */
export function TodaySoFar({ today }: TodaySoFarProps) {
  const { pendingCount, rejectedCount } = useSync()
  const waiting = Math.max(0, pendingCount - rejectedCount)
  return (
    <Box borderWidth="1px" borderColor="border" borderRadius="lg" bg="surface" p={4}>
      <Heading size="sm" mb={3}>Today so far</Heading>
      <HStack gap={2} flexWrap="wrap" align="stretch">
        <Stat value={today?.doors ?? '—'} label="Doors" />
        <Stat value={today?.conversations ?? '—'} label="Conversations" />
        <Stat value={waiting} label="Waiting to sync" />
      </HStack>
    </Box>
  )
}
